import GradeLayout from '@/components/editorLandingPage/layouts/GradeLayout.vue';
import ContainerLayout from '@/components/editorLandingPage/layouts/ContainerLayout.vue';

import ImagemComponente from '@/components/editorLandingPage/componentes/ImagemComponente.vue';
import BannerComponente from '@/components/editorLandingPage/componentes/BannerComponente.vue';
import CardComponente from '@/components/editorLandingPage/componentes/CardComponente.vue';
import BotaoComponente from '@/components/editorLandingPage/componentes/BotaoComponente.vue';
import TextoComponente from '@/components/editorLandingPage/componentes/TextoComponente.vue';
import MapaComponente from '@/components/editorLandingPage/componentes/MapaComponente.vue';
import VideoComponente from '@/components/editorLandingPage/componentes/VideoComponente.vue';
import FormularioComponente from '@/components/editorLandingPage/componentes/FormularioComponente.vue';

import CheckboxInput from '@/components/editorLandingPage/componentes/form/CheckboxInput.vue';
import NumberInput from '@/components/editorLandingPage/componentes/form/NumberInput.vue';
import SelectInput from '@/components/editorLandingPage/componentes/form/SelectInput.vue';
import TextInput from '@/components/editorLandingPage/componentes/form/TextInput.vue';
import TelefoneInput from '@/components/editorLandingPage/componentes/form/TelefoneInput.vue';
import DateInput from '@/components/editorLandingPage/componentes/form/DateInput.vue';

// Ícones: https://fonts.google.com/icons
export const LAYOUTS_DISPONIVEIS = [
    {
        componente: 'grade',
        titulo: 'Grade',
        icone: 'calendar_view_month',
        descricao: 'Layout de duas colunas',
        elemento: GradeLayout,
    },
    {
        componente: 'container',
        titulo: 'Container',
        icone: 'rectangle',
        descricao: 'Layout de um elemento para ajustes de posicionamento',
        elemento: ContainerLayout,
    },
];

export const COMPONENTES_DISPONIVEIS = [
    {
        componente: 'banner',
        titulo: 'Banner/Carrossel',
        icone: 'art_track',
        descricao: 'Imagem em destaque ou carrossel de imagens',
        elemento: BannerComponente,
    },
    {
        componente: 'card',
        titulo: 'Card',
        icone: 'square',
        descricao: 'Card com título, texto e imagem',
        elemento: CardComponente,
    },
    {
        componente: 'botao',
        titulo: 'Botão',
        icone: 'radio_button_checked',
        descricao: 'Botão de ação ou link',
        elemento: BotaoComponente,
    },
    {
        componente: 'texto',
        titulo: 'Texto',
        icone: 'format_color_text',
        descricao: 'Bloco de texto formatável',
        elemento: TextoComponente,
    },
    {
        componente: 'imagem',
        titulo: 'Imagem',
        icone: 'photo',
        descricao: 'Imagem única',
        elemento: ImagemComponente,
    },
    {
        componente: 'video',
        titulo: 'Vídeo',
        icone: 'tv',
        descricao: 'Incorporação de vídeo',
        elemento: VideoComponente,
    },
    {
        componente: 'mapa',
        titulo: 'Mapa',
        icone: 'distance',
        descricao: 'Mapa incorporado',
        elemento: MapaComponente,
    },
    {
        componente: 'formulario',
        titulo: 'Formulário',
        icone: 'format_image_right',
        descricao: 'Formulário de inscrição',
        elemento: FormularioComponente,
    },
];

export const CAMPOS_DISPONIVEIS = [
    {
        componente: 'telefone',
        titulo: 'Telefone',
        icone: '',
        descricao: 'Telefone do participante',
        elemento: TelefoneInput,
        deletavel: true,
        editavel: true,
    },
    {
        componente: 'email',
        titulo: 'E-mail',
        icone: '',
        descricao: 'Email do participante',
        elemento: TextInput,
        deletavel: true,
        editavel: true,
    },
    {
        componente: 'cargo',
        titulo: 'Cargo',
        icone: '',
        descricao: 'Cargo do participante',
        elemento: TextInput,
        deletavel: true,
        editavel: true,
    },
    {
        componente: 'empresa',
        titulo: 'Empresa',
        icone: '',
        descricao: 'Empresa do participante',
        elemento: TextInput,
        deletavel: true,
        editavel: true,
    },
    {
        componente: 'setor',
        titulo: 'Setor',
        icone: '',
        descricao: 'Setor do participante',
        elemento: TextInput,
        deletavel: true,
        editavel: true,
    },
];

export const OUTROS_CAMPOS = [
    {
        componente: 'cabecalho',
        titulo: 'Cabeçalho',
        icone: '',
        descricao: 'Cabeçalho da landing page',
        elemento: null,
    },
    {
        componente: 'rodape',
        titulo: 'Rodapé',
        icone: '',
        descricao: 'Rodapé da landing page',
        elemento: TextInput,
    },
    {
        componente: 'botaoEnviar',
        titulo: 'Botão de Inscrição',
        icone: '',
        descricao: 'Botão de enviar inscrição do formulário',
        elemento: null,
        deletavel: false,
        editavel: false,
    },
    {
        componente: 'botaoLimpar',
        titulo: 'Botão Limpar Campos',
        icone: '',
        descricao: 'Botão para limpar os campos do formulário',
        elemento: BotaoComponente,
        props: {
            texto: 'Limpar Campos',
            acaoBotao: 'limpar',
            cor: '#0e88b3',
            alinhamento: 'start',
        },
        deletavel: false,
        editavel: true,
    },
    {
        componente: 'dataNascimento',
        titulo: 'Data de Nascimento',
        icone: '',
        descricao: 'Data de Nascimento do participante',
        elemento: TextInput,
        deletavel: false,
        editavel: false,
    },
    {
        componente: 'genero',
        titulo: 'Gênero',
        icone: '',
        descricao: 'Gênero do participante',
        elemento: SelectInput,
        deletavel: false,
        editavel: false,
    },
    {
        componente: 'nome',
        titulo: 'Nome',
        icone: '',
        descricao: 'Nome do participante',
        elemento: TextInput,
        editavel: false,
        deletavel: false,
    },
    {
        componente: 'campoTexto',
        titulo: 'Campo de Texto',
        icone: '',
        descricao: 'Campo de texto',
        elemento: TextInput,
        editavel: true,
        deletavel: true,
    },
    {
        componente: 'campoNumerico',
        titulo: 'Campo Numerico',
        icone: '',
        descricao: 'Campo numerico',
        elemento: NumberInput,
        editavel: true,
        deletavel: true,
    },
    {
        componente: 'campoDropdown',
        titulo: 'Selecione uma Opção',
        icone: '',
        descricao: 'Campo dropdown',
        elemento: TextInput,
        editavel: true,
        deletavel: true,
    },
    {
        componente: 'campoCNPJ',
        titulo: 'CNPJ',
        icone: '',
        descricao: 'Campo cnpj',
        elemento: TextInput,
        editavel: true,
        deletavel: true,
    },
    {
        componente: 'campoCep',
        titulo: 'CEP',
        icone: '',
        descricao: 'Campo cep',
        elemento: TextInput,
        editavel: true,
        deletavel: true,
    },
    {
        componente: 'campoEmail',
        titulo: 'E-mail',
        icone: '',
        descricao: 'Campo email',
        elemento: TextInput,
        editavel: true,
        deletavel: true,
    },
    {
        componente: 'campoCheckbox',
        titulo: 'Checkbox',
        icone: '',
        descricao: 'Campo checkbox',
        elemento: CheckboxInput,
        editavel: true,
        deletavel: true,
    },
    {
        componente: 'campoData',
        titulo: 'Data',
        icone: '',
        descricao: 'Campo data',
        elemento: DateInput,
        editavel: true,
        deletavel: true,
    },
];
